import { collection, query, where, getDocs, writeBatch, doc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Normalize legacy student documents
 * For users with role in [null, "", "Student"] that have managedBy but missing teacherId/status/isActive
 */
export async function normalizeLegacyStudents() {
  console.log('🔧 Starting legacy student normalization...');
  
  try {
    // Query users with problematic role values
    const usersRef = collection(db, 'users');
    const q1 = query(usersRef, where('role', '==', null));
    const q2 = query(usersRef, where('role', '==', ''));
    const q3 = query(usersRef, where('role', '==', 'Student'));
    
    // Get all potentially problematic docs
    const [snap1, snap2, snap3] = await Promise.all([
      getDocs(q1),
      getDocs(q2), 
      getDocs(q3)
    ]);
    
    const allDocs = [...snap1.docs, ...snap2.docs, ...snap3.docs];
    const toUpdate = [];
    
    // Filter docs that need updating
    allDocs.forEach(doc => {
      const data = doc.data();
      const managedBy = data.managedBy;
      
      // Only update if has managedBy but missing critical student fields
      if (managedBy && managedBy.length > 0 && 
          (!data.teacherId || !data.status || data.isActive === undefined)) {
        toUpdate.push({
          id: doc.id,
          teacherId: managedBy[0],
          data
        });
      }
    });
    
    if (toUpdate.length === 0) {
      console.log('✅ No legacy students found to normalize');
      return { updated: 0, total: allDocs.length };
    }
    
    // Batch update in chunks of 500
    const batchSize = 500;
    let updated = 0;
    
    for (let i = 0; i < toUpdate.length; i += batchSize) {
      const batch = writeBatch(db);
      const chunk = toUpdate.slice(i, i + batchSize);
      
      chunk.forEach(({ id, teacherId }) => {
        batch.update(doc(db, 'users', id), {
          role: 'student',
          teacherId: teacherId,
          status: 'active', 
          isActive: true
        });
      });
      
      await batch.commit();
      updated += chunk.length;
      console.log(`📝 Updated ${updated}/${toUpdate.length} legacy students...`);
    }
    
    console.log(`✅ Legacy student normalization complete: ${updated} documents updated`);
    return { updated, total: allDocs.length };
    
  } catch (error) {
    console.error('❌ Legacy student normalization failed:', error);
    throw error;
  }
}